export * from '@fhs/routing/src/routes/menu/(menu)/[id]';
export { default } from '@fhs/routing/src/routes/menu/(menu)/[id]';
